import { __decorate, __metadata } from "tslib";
import { CommonModule } from '@angular/common';
import { inject } from '@angular/core';
import { UiContainerComponent } from '@common/ui/frontend-shared/container';
import { UiLoadingIndicatorComponent } from '@common/ui/frontend-shared/loading-indicator';
import { UiMessageComponent } from '@common/ui/frontend-shared/message';
import { UiHeaderComponent } from '@common/ui/frontend-shared/shared';
import { AccessState, CoreFrontendSharedModule, ReplaceableComponent } from '@core/frontend-shared';
import { NgLetDirective } from '@core/frontend-shared/utils';
import { Store } from '@ngxs/store';
import { combineLatest } from 'rxjs';
import { MembershipDisplayMode, MembershipRegistrationFacade, MembershipRegistrationMode, MembershipRegistrationState, RegistrationStep } from '../state';
import { RegistrationCheckoutComponent } from './registration-checkout.component';
import { RegistrationCompleteComponent } from './registration-complete.component';
import { RegistrationFormsComponent } from './registration-forms.component';
import { RegistrationSummaryComponent } from './registration-summary.component';
import { RegistrationTypeSelectionComponent } from './registration-type-selection.component';
import * as i0 from "@angular/core";
import * as i1 from "../state";
import * as i2 from "@ngxs/store";
import * as i3 from "@angular/common";
import * as i4 from "@common/ui/frontend-shared/card";
const _c0 = [[["ui-header"]]];
const _c1 = ["ui-header"];
function RegistrationWrapperComponent_Conditional_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function RegistrationWrapperComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "ui-card");
    i0.ɵɵtemplate(2, RegistrationWrapperComponent_Conditional_0_ng_container_2_Template, 1, 0, "ng-container", 2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const mainWrapper_r2 = i0.ɵɵreference(3);
    i0.ɵɵproperty("uiContainer", !ctx_r0.inline);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", mainWrapper_r2);
  }
}
function RegistrationWrapperComponent_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function RegistrationWrapperComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, RegistrationWrapperComponent_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 2);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const mainWrapper_r2 = i0.ɵɵreference(3);
    i0.ɵɵproperty("ngTemplateOutlet", mainWrapper_r2);
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵprojection(1);
    i0.ɵɵelement(2, "br")(3, "br");
    i0.ɵɵelementEnd();
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_ng_template_1_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "membership-registration-type-selection")(1, "membership-registration-forms");
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_ng_template_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_ng_template_1_Conditional_0_Conditional_0_Template, 2, 0);
  }
  if (rf & 2) {
    const currentStep_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(5);
    i0.ɵɵconditional(currentStep_r3 === ctx_r0.RegistrationStep.membershipTypeSelection || currentStep_r3 === ctx_r0.RegistrationStep.forms ? 0 : -1);
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_ng_template_1_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "membership-registration-type-selection");
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_ng_template_1_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "membership-registration-forms");
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_ng_template_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_ng_template_1_Conditional_1_Conditional_0_Template, 1, 0, "membership-registration-type-selection");
    i0.ɵɵconditionalCreate(1, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_ng_template_1_Conditional_1_Conditional_1_Template, 1, 0, "membership-registration-forms");
  }
  if (rf & 2) {
    const currentStep_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(5);
    i0.ɵɵconditional(currentStep_r3 === ctx_r0.RegistrationStep.membershipTypeSelection ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(currentStep_r3 === ctx_r0.RegistrationStep.forms ? 1 : -1);
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_ng_template_1_Conditional_2_ng_template_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "membership-registration-checkout");
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_ng_template_1_Conditional_2_ng_template_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "membership-registration-summary");
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_ng_template_1_Conditional_2_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_ng_template_1_Conditional_2_ng_template_0_Conditional_0_Template, 1, 0, "membership-registration-checkout");
    i0.ɵɵconditionalCreate(1, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_ng_template_1_Conditional_2_ng_template_0_Conditional_1_Template, 1, 0, "membership-registration-summary");
  }
  if (rf & 2) {
    const info_r4 = ctx.$implicit;
    i0.ɵɵconditional(info_r4.requiresPayment ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!info_r4.requiresPayment ? 1 : -1);
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_ng_template_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_ng_template_1_Conditional_2_ng_template_0_Template, 2, 2, "ng-template", 4);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("ngLet", i0.ɵɵpipeBind1(1, 1, ctx_r0.innerRegistrationInfo$));
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_ng_template_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "membership-registration-complete");
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_ng_template_1_Conditional_0_Template, 1, 1);
    i0.ɵɵconditionalCreate(1, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_ng_template_1_Conditional_1_Template, 2, 2);
    i0.ɵɵconditionalCreate(2, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_ng_template_1_Conditional_2_Template, 2, 3, null, 4);
    i0.ɵɵconditionalCreate(3, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_ng_template_1_Conditional_3_Template, 1, 0, "membership-registration-complete");
  }
  if (rf & 2) {
    const currentStep_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(5);
    i0.ɵɵconditional(ctx_r0.inline ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.inline ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(currentStep_r3 === ctx_r0.RegistrationStep.summary ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(currentStep_r3 === ctx_r0.RegistrationStep.complete ? 3 : -1);
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_Conditional_0_Template, 4, 0, "div", 5);
    i0.ɵɵtemplate(1, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_ng_template_1_Template, 4, 4, "ng-template", 4);
    i0.ɵɵpipe(2, "async");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵconditional(ctx_r0.headerFacet ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngLet", i0.ɵɵpipeBind1(2, 2, ctx_r0.currentStep$));
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2");
    i0.ɵɵtext(1, "Zahlung abschlie\u00DFen");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "p");
    i0.ɵɵtext(3, "Ihr Zugang wurde noch nicht freigeschaltet, da die Zahlung noch aussteht.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p");
    i0.ɵɵtext(5, "Diese Funktion steht leider noch nicht zur Verf\u00FCgung. Bitte kontaktieren Sie stattdessen den Support.");
    i0.ɵɵelementEnd();
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_2_ng_template_8_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " TODO: selecting membership type is not implemented atm. ");
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_2_ng_template_8_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "membership-registration-forms");
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_2_ng_template_8_Conditional_2_ng_template_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "membership-registration-checkout");
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_2_ng_template_8_Conditional_2_ng_template_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "membership-registration-summary");
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_2_ng_template_8_Conditional_2_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_2_ng_template_8_Conditional_2_ng_template_0_Conditional_0_Template, 1, 0, "membership-registration-checkout");
    i0.ɵɵconditionalCreate(1, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_2_ng_template_8_Conditional_2_ng_template_0_Conditional_1_Template, 1, 0, "membership-registration-summary");
  }
  if (rf & 2) {
    const info_r5 = ctx.$implicit;
    i0.ɵɵconditional(info_r5.requiresPayment ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!info_r5.requiresPayment ? 1 : -1);
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_2_ng_template_8_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_2_ng_template_8_Conditional_2_ng_template_0_Template, 2, 2, "ng-template", 4);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("ngLet", i0.ɵɵpipeBind1(1, 1, ctx_r0.innerRegistrationInfo$));
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_2_ng_template_8_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "membership-registration-complete");
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_2_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_2_ng_template_8_Conditional_0_Template, 1, 0);
    i0.ɵɵconditionalCreate(1, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_2_ng_template_8_Conditional_1_Template, 1, 0, "membership-registration-forms");
    i0.ɵɵconditionalCreate(2, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_2_ng_template_8_Conditional_2_Template, 2, 3, null, 4);
    i0.ɵɵconditionalCreate(3, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_2_ng_template_8_Conditional_3_Template, 1, 0, "membership-registration-complete");
  }
  if (rf & 2) {
    const currentStep_r6 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(5);
    i0.ɵɵconditional(currentStep_r6 === ctx_r0.RegistrationStep.membershipTypeSelection ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(currentStep_r6 === ctx_r0.RegistrationStep.forms ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(currentStep_r6 === ctx_r0.RegistrationStep.summary ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(currentStep_r6 === ctx_r0.RegistrationStep.complete ? 3 : -1);
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2");
    i0.ɵɵtext(1, "Mitgliedschaft fortsetzen");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 5)(3, "ui-message");
    i0.ɵɵtext(4, " Bitte pr\u00FCfen Sie Ihre vorhandenen Eingaben und f\u00FCllen Sie ggf. fehlende Angaben neu aus.");
    i0.ɵɵelement(5, "br");
    i0.ɵɵtext(6, " Wenn Ihre aktuelle Mitgliedschaft noch g\u00FCltig ist, werden diese Tage zur neuen Mitgliedschaft hinzugef\u00FCgt. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "br");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_2_ng_template_8_Template, 4, 4, "ng-template", 4);
    i0.ɵɵpipe(9, "async");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngLet", i0.ɵɵpipeBind1(9, 1, ctx_r0.currentStep$));
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_0_Template, 3, 4);
    i0.ɵɵconditionalCreate(1, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_1_Template, 6, 0);
    i0.ɵɵconditionalCreate(2, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Conditional_2_Template, 10, 3);
  }
  if (rf & 2) {
    const mode_r7 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional(mode_r7 === ctx_r0.MembershipRegistrationMode.create ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(mode_r7 === ctx_r0.MembershipRegistrationMode.completePayment ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(mode_r7 === ctx_r0.MembershipRegistrationMode.registered ? 2 : -1);
  }
}
function RegistrationWrapperComponent_ng_template_2_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, RegistrationWrapperComponent_ng_template_2_ng_template_2_ng_template_0_Template, 3, 3, "ng-template", 4);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngLet", i0.ɵɵpipeBind1(1, 1, ctx_r0.mode$));
  }
}
function RegistrationWrapperComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ui-loading-indicator", 3);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵtemplate(2, RegistrationWrapperComponent_ng_template_2_ng_template_2_Template, 2, 3, "ng-template");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("loading", i0.ɵɵpipeBind1(1, 1, ctx_r0.isBusy$));
  }
}
/**
 * this is starting point of registration.
 */
let RegistrationWrapperComponent = /*#__PURE__*/(() => {
  let RegistrationWrapperComponent = class RegistrationWrapperComponent {
    constructor(registration, store) {
      this.registration = registration;
      this.store = store;
      this.inline = false; // indicates component is rendered in compact view somewhere within another page
      this.mode$ = inject(Store).select(MembershipRegistrationState.mode);
      this.isBusy$ = inject(Store).select(MembershipRegistrationState.isBusy);
      this.currentStep$ = inject(Store).select(MembershipRegistrationState.currentStep);
      this.requiresPayment$ = inject(Store).select(MembershipRegistrationState.requiresPayment);
      this.redirectInProgress$ = inject(Store).select(MembershipRegistrationState.redirectInProgress);
      this.RegistrationStep = RegistrationStep;
      this.MembershipRegistrationMode = MembershipRegistrationMode;
      this.innerRegistrationInfo$ = combineLatest({
        requiresPayment: this.requiresPayment$
      });
      // if user is logged in, configurate state to handle completion or renewal of existing membership.
      const loggedIn = store.selectSnapshot(AccessState.loggedIn);
      const membershipPaymentPending = store.selectSnapshot(AccessState.accessData('membershipPaymentPending'));
      if (loggedIn) {
        if (membershipPaymentPending) {
          registration.setRegistrationMode(MembershipRegistrationMode.completePayment);
        } else {
          registration.setRegistrationMode(MembershipRegistrationMode.registered);
        }
      }
    }
    ngOnInit() {
      const displayMode = this.inline ? MembershipDisplayMode.compact : MembershipDisplayMode.full;
      this.registration.setDisplayMode(displayMode);
    }
    static {
      this.ɵfac = function RegistrationWrapperComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RegistrationWrapperComponent)(i0.ɵɵdirectiveInject(i1.MembershipRegistrationFacade), i0.ɵɵdirectiveInject(i2.Store));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: RegistrationWrapperComponent,
        selectors: [["membership-registration-wrapper"]],
        contentQueries: function RegistrationWrapperComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, UiHeaderComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerFacet = _t.first);
          }
        },
        inputs: {
          inline: "inline"
        },
        ngContentSelectors: _c1,
        decls: 4,
        vars: 2,
        consts: [["mainWrapper", ""], [3, "uiContainer"], [4, "ngTemplateOutlet"], [3, "loading"], [3, "ngLet"], [1, "ui-card-header"]],
        template: function RegistrationWrapperComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c0);
            i0.ɵɵconditionalCreate(0, RegistrationWrapperComponent_Conditional_0_Template, 3, 2, "div", 1);
            i0.ɵɵconditionalCreate(1, RegistrationWrapperComponent_Conditional_1_Template, 1, 1, "ng-container");
            i0.ɵɵtemplate(2, RegistrationWrapperComponent_ng_template_2_Template, 3, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.inline ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.inline ? 1 : -1);
          }
        },
        dependencies: [CommonModule, i3.NgTemplateOutlet, CoreFrontendSharedModule, NgLetDirective, UiContainerComponent, i4.UiCardComponent, UiLoadingIndicatorComponent, UiMessageComponent, RegistrationTypeSelectionComponent, RegistrationFormsComponent, RegistrationSummaryComponent, RegistrationCheckoutComponent, RegistrationCompleteComponent, i3.AsyncPipe],
        styles: ["[_nghost-%COMP%]{margin:0;display:block;padding:30px 0}\n\n/*# sourceMappingURL=registration-wrapper.component.ts-angular-inline--51.css.map*/", ".reset-wrapper[_ngcontent-%COMP%]{margin:40px auto 0;text-align:center}\n\n/*# sourceMappingURL=registration-wrapper.component.ts-angular-inline--52.css.map*/"],
        changeDetection: 0
      });
    }
  };
  RegistrationWrapperComponent = __decorate([ReplaceableComponent(), __metadata("design:paramtypes", [MembershipRegistrationFacade, Store])], RegistrationWrapperComponent);
  return RegistrationWrapperComponent;
})();
export { RegistrationWrapperComponent };